var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEscrowBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 234,
    viewBox: "0 0 435 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.329102,
    width: 434.323,
    height: 233.671,
    rx: 17.8,
    transform: "rotate(-0.0434388 0 0.329102)",
    fill: "#0C0C0C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1780_1420",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 0,
    width: 409,
    height: 224
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 408.481,
    height: 223.494,
    rx: 17.8,
    transform: "matrix(1 -0.000763289 0.000753047 1 13 0.311523)",
    fill: "#ED713C"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1780_1420)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M354.123 -9.23516C357.304 3.82684 347.858 15.9109 345.366 29.1269C342.642 43.5717 351.36 64.2482 338.869 71.6611C325.594 79.5385 311.046 56.7836 295.776 58.555C279.04 60.4963 268.701 84.4088 252.064 81.7307C235.617 79.0832 219.178 62.9771 218.221 46.0708C217.224 28.4566 241.253 20.3983 247.664 4.00349C252.675 -8.81344 238.117 -30.4516 250.416 -36.2659C264.332 -42.8447 275.551 -15.4311 290.866 -16.4203C306.09 -17.4036 313.055 -43.0129 328.215 -41.291C342.07 -39.7171 350.771 -22.9977 354.123 -9.23516Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M370.264 130.066C385.942 128.883 402.326 122.442 416.271 129.823C430.948 137.59 443.758 152.766 444.876 169.553C445.962 185.865 429.495 196.895 421.689 211.187C415.851 221.875 412.834 233.43 404.947 242.657C394.96 254.342 385.369 268.582 370.37 271.231C354.613 274.013 337.155 268.103 325.823 256.627C315.036 245.704 317.148 228.132 313.079 213.215C309.257 199.204 299.798 186.213 302.734 171.983C305.799 157.123 316.179 144.324 328.923 136.414C341.117 128.845 356.017 131.141 370.264 130.066Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8998 109.709C59.8874 107.554 80.2318 103.138 90.744 115.576C101.69 128.528 87.703 148.831 91.1007 165.556C93.8764 179.219 108.377 188.458 108.384 202.41C108.393 218.82 103.582 236.668 91.1425 247.121C78.4918 257.753 59.624 261.646 44.0093 256.51C29.4611 251.725 26.9601 231.471 14.8206 222.017C3.23542 212.995 -17.1134 216.795 -23.874 203.645C-30.5738 190.613 -21.6221 174.997 -16.4026 161.283C-11.4707 148.324 -5.19944 136.043 5.25798 127.099C16.3084 117.648 29.5862 111.638 43.8998 109.709Z",
    fill: "white",
    fillOpacity: 0.05
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEscrowBg);
export default __webpack_public_path__ + "static/media/escrow_bg.43cf04ecfe15b47f8d52b02b53345253.svg";
export { ForwardRef as ReactComponent };